<script setup lang="ts">
import type { WidgetBody } from '@/types/appTypes'

const app = useNuxtApp()
const storeIndex = useStoreIndex()
const storeArticleList = useStoreArticleList()

definePageMeta({ layout: 'layout-single' })

const pageData = {
  topAdSp: null as WidgetBody | null,
  topAdPc: null as WidgetBody | null,
}
const refData = reactive({ socialError: null })

const setHead = () => {
  const headBase = '新規登録'
  const headTitle = '新規登録 | IMメンバー'
  const headDesc = `日本最大級のミュージアム情報サイト、アイエム［インターネットミュージアム］による、ミュージアム情報の掲示板。ミュージアムに関連する話題なら、どなたでもご利用いただけます。美術館・博物館の情報はアイエムで！`

  // ぱんくず作成
  storeIndex.setBreadCrumbs([
    {
      text: headBase,
      disabled: true,
    },
  ])

  useHead({
    title: headTitle,
    meta: [
      {
        name: 'description',
        content: headDesc,
      },
    ],
  })
}

const socialEntry = async (site) => {
  try {
    const res = await app.$OauthApi.oauthRedirect(
      site,
      'entry',
    )
    if (res.data.code === 200000) {
      const url = res.data.data.url
      // const url = res.data.data.url.replace('im-stg.arcplg-lab.com', 'localhost')
      if (url) {
        window.location.href = url
      }
    } else {
      refData.socialError = 'SNS認証:APIエラー'
    }
  } catch (e) {
    throw createError({
      statusCode: 500,
      statusMessage: `SNS認証エラー`,
    })
  }
}

const onToRegist = () => {
  navigateTo({ name: 'registration' })
}

const onToLogin = () => {
  navigateTo({ name: 'login' })
}

const onClickSocial = (site) => {
  socialEntry(site)
}

const initPage = async () => {
  refData.socialError = null

  const [_resSite, _resMaster, resList] = await Promise.all([
    storeIndex.fetchSite(),
    storeIndex.fetchMaster(),
    storeArticleList.loadTopLikeBanner(),
  ])

  if (resList.code === 200000) {
    pageData.topAdSp = resList.data
    pageData.topAdPc = resList.data
  }
}
await initPage()
setHead()
</script>

<template>
  <div
    class="p-singlePage"
  >
    <h2 class="c-heading_page">
      新規登録
    </h2>
    <div class="p-main">
      <div class="p-main_confirmBox">
        <div class="p-main_confirmBox_title">
          IMメンバーになると、お得な特典がいっぱい！
        </div>
        <v-divider class="p-main_confirmBox_divider" />
        <div class="p-main_confirmBox_infoGroup">
          <table>
            <tbody>
              <tr>
                <td>
                  <span class="p-main_confirmBox_infoGroup_blackText">
                    毎日更新！
                  </span>
                  <span class="p-main_confirmBox_infoGroup_blueText">
                    プレゼント
                  </span>
                  <span class="p-main_confirmBox_infoGroup_blackText">
                    に応募できる
                  </span>
                </td>
                <td>
                  <span class="p-main_confirmBox_infoGroup_blueText">
                    クリップ機能
                  </span>
                  <span class="p-main_confirmBox_infoGroup_blackText">
                    （お気に入り）が使える
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="p-main_confirmBox_infoGroup_blackText">
                    「もうすぐ始まる／終わる 展覧会」が
                  </span>
                  <span class="p-main_confirmBox_infoGroup_blueText">
                    メールで届く
                  </span>
                </td>
                <td>
                  <span class="p-main_confirmBox_infoGroup_blackText">
                    「
                  </span>
                  <span class="p-main_confirmBox_infoGroup_blueText">
                    For You
                  </span>
                  <span class="p-main_confirmBox_infoGroup_blackText">
                    」機能で、あなた好みの情報が見られる
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="p-main_confirmBox_infoGroup_blackText">
                    「
                  </span>
                  <span class="p-main_confirmBox_infoGroup_blueText">
                    マイ ミュージアム メモ
                  </span>
                  <span class="p-main_confirmBox_infoGroup_blackText">
                    」で、観賞レポートも書ける
                  </span>
                </td>
                <td>
                  <span class="p-main_confirmBox_infoGroup_blueText">
                    学芸員募集
                  </span>
                  <span class="p-main_confirmBox_infoGroup_blackText">
                    の詳細が閲覧できる
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="p-main_action"
      >
        <v-btn
          class="c-btn_formSubmit"
          color="primary"
          v-on:click="onToRegist"
        >
          メールアドレスで新規登録
        </v-btn>
      </div>

      <template
        v-if="app.isMobile"
      >
        <div
          class="c-listAdvertise"
        >
          <div
            v-if="pageData.topAdSp?.body"
            class="c-listAdvertise_advertiseCms c-advertise"
            v-html="pageData.topAdSp.body"
          />
          <!--
          <div
            class="c-listAdvertise_advertise c-advertise"
          >
            <adsbygoogle
              ad-slot="9530995886"
              ad-format="auto"
            ></adsbygoogle>
          </div>
          -->
        </div>
      </template>

      <div class="p-main_groupLink">
        <div class="p-main_groupLink_anotherLogin">
          <!-- 現在SNSログインで不具合が発生しています。<br>
          今しばらくお待ちください。 -->
          <div
            v-show="1"
          >
            <div class="p-main_groupLink_anotherLogin_title">
              ソーシャルIDで新規登録する
            </div>
            <div class="p-form_notice">
              <template
                v-if="refData.socialError"
              >
                {{ refData.socialError }}
              </template>
            </div>
            <button
              class="p-main_groupLink_anotherLogin_linkButton"
              v-on:click="onClickSocial('facebook')"
            >
              <img
                src="@/assets/images/login-fb-icon.png"
                class="p-main_groupLink_anotherLogin_linkButton_iconFaceBook"
              >
              Facebookで登録
            </button>
            <button
              class="p-main_groupLink_anotherLogin_linkButton"
              v-on:click="onClickSocial('line')"
            >
              <img
                src="@/assets/images/logo-social-line.png"
                class="p-main_groupLink_anotherLogin_linkButton_iconLine"
              >
              Lineで登録
            </button>
          </div>
        </div>
      </div>

      <template
        v-if="!app.isMobile"
      >
        <div
          class="c-listAdvertise"
        >
          <div
            v-if="pageData.topAdPc?.body"
            class="c-listAdvertise_advertiseCms c-advertise"
            v-html="pageData.topAdPc.body"
          />
          <!--
          <div
            class="c-listAdvertise_advertise c-advertise"
          >
            <adsbygoogle
              ad-slot="7741488425"
              ad-format="auto"
            ></adsbygoogle>
          </div>
          <div
            class="c-listAdvertise_advertise c-advertise"
          >
            <adsbygoogle
              ad-slot="7612157228"
              ad-format="auto"
            ></adsbygoogle>
          </div>
          -->
        </div>
      </template>

      <div class="c-memberLogin">
        <div class="c-memberLogin_title">
          既に登録のお済みの方は、こちらから
        </div>
        <v-btn
          class="c-btn_formSubmit"
          color="primary"
          v-on:click="onToLogin"
        >
          <v-icon>mdi-login</v-icon>
          ログイン
        </v-btn>
      </div>
    </div>

    <!--
    <template
      v-if="$device.isMobile"
    >
      <div
        class="c-listAdvertise"
      >
        <div
          class="c-listAdvertise_advertise c-advertise"
        >
          <adsbygoogle
            ad-slot="5687953794"
            ad-format="auto"
          ></adsbygoogle>
        </div>
      </div>
    </template>
    -->
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive" as *;

.p-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;
  padding-bottom: 120px;

  @include mq_down(sp) {
    margin-top: 30px;
    padding-bottom: 0;
  }

  &_confirmBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 792px;
    margin-bottom: 60px;
    border: 4px solid var(--color_background_whiteblue);

    @include mq_down(sp) {
      display: block;
      box-sizing: border-box;
      width: 100%;
      max-width: 400px;
      margin: 0 auto 45px;
    }

    &_title {
      margin-top: 15px;
      margin-bottom: 10px;
      color: var(--color_primary);
      font-size: 18px;
      font-weight: bold;

      @include mq_down(sp) {
        margin: 0;
        padding: 20px;
        font-size: var(--g_fontSize_h2_sp);
      }
    }

    &_divider {
      width: 670px;
      height: 1px;

      @include mq_down(sp) {
        width: 100%;
      }
    }

    &_infoGroup {
      margin-top: 15px;
      margin-bottom: 25px;

      @include mq_down(sp) {
        margin: 0;
        padding: 20px;
      }

      td {
        padding: 0 25px;
      }

      @include mq_down(sp) {
        & > table,
        & > table > tbody,
        & > table > tbody > tr,
        & > table > tbody > tr > td {
          display: block;
        }

        & > table > tbody > tr > td {
          padding: 0;
          padding-left: 0.5em;
          text-indent: -0.5em;
        }
      }

      &_blueText {
        color: var(--color_primary);
        font-size: 14px;
        font-weight: bold;
      }

      &_blackText {
        color: var(--color_text_base);
        font-size: 14px;
        font-weight: bold;
      }
    }
  }

  &_title {
    margin-top: 70px;
    margin-bottom: 30px;
    color: var(--color_text_base);
    font-size: 20px;
    font-weight: bold;

    @include mq_down(sp) {
      margin-top: 50px;
      font-size: var(--g_fontSize_h2);
      text-align: center;
    }
  }

  &_action {
    display: flex;
    justify-content: center;
  }

  &_groupLink {
    width: 100%;
    margin-top: 30px;
    background-color: #f8fafb;

    @include mq_down(sp) {
      // margin-top: 60px;
    }

    &_anotherLogin {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 25px 0 40px;

      @include mq_down(sp) {
        margin: 0;
        padding: 20px;
      }

      &_title {
        margin-bottom: 5px;
        color: var(--g_color_button_text_black);
        font-size: 20px;
        font-weight: bold;

        @include mq_down(sp) {
          font-size: 18px;
        }
      }

      &_linkButton {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 278px;
        height: 40px;
        margin-top: 15px;
        margin-left: -10px;
        background-color: var(--g_color_background_white);
        color: var(--g_color_button_text_black);
        font-size: 14px;

        @include mq_down(sp) {
          width: 100%;
          max-width: 300px;
          margin: 6px 0;
        }

        &_iconFaceBook {
          width: 9px;
          height: 16px;
          margin-right: 20px;
        }

        &_iconTwitter {
          width: 16px;
          height: 14px;
          margin-right: 10px;
        }

        &_iconLine {
          width: 18px;
          height: 18px;
          margin-right: 10px;
        }
      }

      &_notice {
        max-width: 722px;
        margin: 0 auto;
        padding: 0 40px 30px;
        font-size: 14px;
        text-align: center;
      }
    }
  }
}

.c-memberLogin {
  margin-top: 70px;
  margin-bottom: 20px;
  text-align: center;

  @include mq_down(sp) {
    margin: 50px 0 30px;
  }

  &_title {
    margin-bottom: 28px;
    font-size: 20px;
    font-weight: 700;

    @include mq_down(sp) {
      font-size: 18px;
    }
  }

  &_btn {
    margin: 0 auto 20px;
  }

  &_pwlink {
    font-size: 14px;
  }
}

.c-loginBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 280px;
  height: 48px;
  transition-duration: var(--g_transition_button_hover);
  border-radius: 6px;
  background-color: var(--color_primary);
  color: var(--g_color_button_text_white);

  &_icon {
    width: 25px;
    height: 21px;
    transform: translateX(-20px);
  }

  &:hover {
    background-color: var(--g_color_button_background_hover_0162f0);
  }
}

.c-object_sp {
  display: none;

  @include mq_down(sp) {
    display: block;
  }
}

.c-listAdvertise {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;

  &.is-onlyPC {
    @include mq_down(sp) {
      display: none;
    }
  }

  &.is-onlySP {
    display: none;

    @include mq_down(sp) {
      display: flex;
    }
  }

  &_advertise {
    width: 334px;

    // height: 280px;
    margin: 60px 15px 30px;

    @include mq_down(sp) {
      width: 100%;
      max-width: 334px;
      margin: 30px 0 0;
    }
  }

  &_advertiseCms {
    width: 334px;
    height: auto;
    margin: 60px 15px 30px;

    @include mq_down(sp) {
      width: 100%;
      max-width: 334px;
      height: auto;
      margin: 30px 0 0;
    }
  }
}
</style>
